import { SearchableMultiSelectProps } from '@healthnz-prm/fhir-engine-renderer/types'
import { InputFieldset } from '../inputFieldset'
import { AsyncCombobox } from '@/components/ui/async-combobox'
import { adaptPage, toOption } from './SearchableSelect'

export { toOption } from './SearchableSelect'

export default function SearchableMultiSelect(
  props: SearchableMultiSelectProps
) {
  const {
    inputId,
    label,
    onBlur,
    onChange,
    onFocus,
    getOptions,
    required,
    value
  } = props

  return (
    <InputFieldset {...props}>
      <AsyncCombobox
        multiple
        loadOptions={query => getOptions(query || undefined).then(adaptPage)}
        value={(value ?? []).map(toOption)}
        onChange={options => onChange(options.map(option => option.data))}
        id={inputId}
        aria-label={label}
        required={required}
        onBlur={onBlur}
        onFocus={onFocus}
      />
    </InputFieldset>
  )
}
